const SPANISH_LANGUAGE_CODE = 'es'

/**
 * The help chatbot only answers in Spanish, so it stays hidden for every other language.
 * @param {string} language
 * @returns {boolean}
 */
export function isHelpChatAvailable(language) {
    if (typeof language !== 'string') {
        return false
    }

    const normalizedLanguage = language.trim().toLowerCase()
    if (normalizedLanguage === '') {
        return false
    }

    const primaryLanguage = normalizedLanguage.split(/[_-]/)[0]
    return primaryLanguage === SPANISH_LANGUAGE_CODE
}
